
<div>
	<!-- Mobile Navigation side bar -->
	<mobile-nav-drawer v-if="$vuetify.breakpoint.mdAndDown" v-model="drawer" :user-type="userType"></mobile-nav-drawer>

	<!-- Top Navigation Bar -->
	<v-toolbar color="transparent" short tile elevation="0" class="mt-2" height="80px">
		<!-- Logo Wrapper -->
		<a :href="tenant.settings.brandUrl" target="_blank">
			<v-img :src="logoFileName" cover width="300px" />
		</a>

		<!-- Locum Tabs Wrapper -->
		<v-tabs v-if="$vuetify.breakpoint.mdAndUp && showMenuTabs" color="secondary" :hide-slider="true" active-class="text--secondary" centered class="ml-4">
			<v-tab :href="menuLinks.faq" target="_blank" router class="text-none font-weight-bold">FAQ</v-tab>
			<!-- <v-tab :href="menuLinks.tutorials" target="_blank" router class="text-none font-weight-bold">Tutorials</v-tab> -->
			<v-tab v-if="!tenant.settings.navigation.hideTutorials" :href="menuLinks.tutorials" target="_blank" router class="text-none font-weight-bold">Tutorials</v-tab>
			<v-tab :href="menuLinks.contact" target="_blank" router class="text-none font-weight-bold">Contact</v-tab>
		</v-tabs>
		<UnreadMessages
			v-if="unreadMessageCount > 0 && !showPractice && !isCompanyDashboardPage && $vuetify.breakpoint.mdAndUp && showMenuTabs"
			:unreadcount="unreadMessageCount"
			style="width: 5rem"
		/>
		<v-spacer></v-spacer>

		<!-- Pricing Dialog -->
		<v-btn
			v-if="showPractice && isCompanyDashboardPage && tenant.settings.pricing.show"
			class="mr-4 hidden-sm-and-down secondary--text font-weight-bold"
			depressed
			@click="openPricingDialog"
		>
			Pricing Options
		</v-btn>

		<v-btn v-if="showPractice && isCompanyDashboardPage" color="#5f6169" class="mr-4 hidden-sm-and-down white--text font-weight-bold" depressed @click="openRequestForm">
			Permanent Placements
		</v-btn>

		<!-- Locum Directory -->
		<v-btn v-if="showPractice && isCompanyDashboardPage" class="mr-4 hidden-sm-and-down primary--text font-weight-bold" depressed @click="openProfessionalDirectory">
			{{ getLabel('professionalDirectory', 'Locum Directory') }}
		</v-btn>

		<!-- Inbox Messages -->
		<!-- For Mobile -->

		<UnreadMessages
			v-if="unreadMessageCount > 0 && showPractice && isCompanyDashboardPage && $vuetify.breakpoint.mdAndUp"
			:unreadcount="unreadMessageCount"
			style="width: 5rem"
		/>
		<v-spacer />
		<!-- Inbox Messages -->
		<!-- For Mobile -->
		<div>
			<UnreadMessages
				v-if="unreadMessageCount > 0 && showLocum && !isCompanyDashboardPage && !$vuetify.breakpoint.mdAndUp"
				:unreadcount="unreadMessageCount"
				class="mr-4 hidden-sm-and-down font-weight-bold white--text"
			/>
		</div>
		<!-- Wallet -->
		<div v-if="tenant.settings.wallet.show">
			<v-btn label color="secondary" :class="[contrastOnSecondary, 'mr-4', 'hidden-sm-and-down', 'font-weight-bold']" @click="openWallet">
				<v-img :src="require('@/assets/images/LocumWallet logo_icon blue.png')" max-width="30" class="mr-2"></v-img>
				{{ getWallet.generalLabel }} R{{ getWallet.total }}
			</v-btn>
		</div>

		<div v-if="tenant.settings.workflow.professionalProfile.invitesActive && user.locale === 'company'">
			<v-btn color="secondary" :class="[contrastOnSecondary, 'mr-4', 'hidden-sm-and-down', 'font-weight-bold']" @click="inviteLocum">Invite Locum</v-btn>
		</div>

		<!-- Practice avatar/menu -->
		<prac-nav-drawer-desktop
			v-if="showPractice"
			:custom-color="textColor"
			:profile-disabled="disableEditProfile"
			:account-disabled="disableAccount"
			:show-wallet="tenant.settings.wallet.show"
		/>

		<!-- Locum avatar/menu -->
		<locum-nav-drawer-desktop v-if="showLocum" :custom-color="textColor" :account-disabled="disableAccount" :profile-disabled="disableEditProfile" />

		<!-- Mobile Side Hamburger Menu Icon -->
		<v-app-bar-nav-icon v-if="$vuetify.breakpoint.mdAndDown" color="textColor" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
	</v-toolbar>
</div>
